import { ExplorerMenuItem } from 'src/components/explorer/shared/ExplorerMenuItem';
import type { Board, Table } from 'src/generated/graphql';
import { TablesExplorerLabel } from './TablesExplorerLabel';

type TablesExplorerItemProps = {
  item: Board | Table;
  selected: Table | null;
  onSelect: (table: Table) => void;
};

export const TablesExplorerItem = ({
  item,
  selected,
  onSelect,
}: TablesExplorerItemProps) => {
  const isBoard = 'tables' in item;
  const hasChildren = isBoard && item.tables?.length > 0;

  if (isBoard) {
    return (
      <ExplorerMenuItem
        hasChildren={hasChildren}
        selected={false}
        onClick={() => {}}
        labelChild={<TablesExplorerLabel item={item} />}
        isSelectable={false}
        childrenChild={item.tables.map((table) => (
          <TablesExplorerItem
            key={table._id}
            item={table}
            selected={selected}
            onSelect={onSelect}
          />
        ))}
      />
    );
  }

  return (
    <ExplorerMenuItem
      hasChildren={false}
      selected={selected?._id === item._id}
      onClick={async () => await onSelect(item as Table)}
      labelChild={<TablesExplorerLabel item={item} />}
      childrenChild={null}
    />
  );
};
